import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GameApi } from './game-api';
import {
  GameConfig,
  GameSummary,
  QuizSubmitRequest,
  QuizSubmitResult,
  QuizTransactionSubmitRequest,
  UserState,
  WheelSpinResult,
} from './game-api.types';
import { QuizDto, mapQuizToGameSummary } from './quiz-mapper';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class HttpGameApi extends GameApi {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
  ) {
    super();
  }

  getGames(): Observable<GameSummary[]> {
    return this.http.get<GameSummary[]>(`${this.baseUrl}/games`);
  }

  fetchGameByGameId(gameId: string): Observable<unknown> {
    return this.http.get<unknown>(this.baseUrl, { params: { gameId } });
  }

  fetchGamesFromQuiz(gameId: string): Observable<GameSummary[]> {
    return this.http
      .get<{ quiz: QuizDto[] }>(this.baseUrl, { params: { gameId } })
      .pipe(map((res) => (res.quiz || []).map((q) => mapQuizToGameSummary(q))));
  }

  getGame(gameId: string): Observable<GameConfig> {
    return this.http.get<GameConfig>(`${this.baseUrl}/games/${gameId}`);
  }

  submitQuiz(req: QuizSubmitRequest): Observable<QuizSubmitResult> {
    return this.http.post<QuizSubmitResult>(
      `${this.baseUrl}/quiz/${req.gameId}/submit`,
      { answers: req.answers },
    );
  }

  submitTransaction(
    req: QuizTransactionSubmitRequest,
  ): Observable<QuizSubmitResult> {
    return this.http.post<QuizSubmitResult>(`${this.baseUrl}/submit-quiz`, {
      txUuid: req.txUuid,
    });
  }

  spinWheel(): Observable<WheelSpinResult> {
    return this.http.post<WheelSpinResult>(`${this.baseUrl}/spin`, {});
  }

  getUserState(): Observable<UserState> {
    return this.http.get<UserState>(`${this.baseUrl}/user/state`);
  }
}
